import { OrderCrudProvider } from "../../../context/OrderCrudContext";
import StepFour from "../../../components/Forms/FormsSteppers/Orders/StepFour";

const OrdersCreate = () => {

    return (
        <OrderCrudProvider>
            <StepFour />
        </OrderCrudProvider>
    )
}
export default OrdersCreate;